/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Represents the columns that can be displayed on the proposal worksheet, includes those that the user cannot deselect0 = Unit

1 = Markup

2 = Client Price

3 = Margin

4 = Profit

5 = % Invoiced

6 = Description

7 = Internal Notes

8 = Cost Type

9 = Unit Cost

10 = Quantity

11 = Builder Cost

12 = Items

13 = Tax

14 = Actions

15 = Unit Price


 */
export type ProposalDisplayColumnTypes =
  (typeof ProposalDisplayColumnTypes)[keyof typeof ProposalDisplayColumnTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProposalDisplayColumnTypes = {
  Unit: 0,
  Markup: 1,
  OwnerPrice: 2,
  Margin: 3,
  Profit: 4,
  PercentInvoiced: 5,
  Description: 6,
  InternalNotes: 7,
  CostType: 8,
  UnitCost: 9,
  Quantity: 10,
  BuilderCost: 11,
  Items: 12,
  Tax: 13,
  Actions: 14,
  UnitPrice: 15,
} as const;
